import React from "react";
import { useForm } from "react-hook-form";

const TypePayment = ({ setFormConfig, user, setUser }) => {
  const {
    register,
    handleSubmit,
    watch,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      tipo: "",
    },
  });

  const OnSubmit = handleSubmit(async (data) => {
    setUser({ ...user, tipo: data.tipo });
    setFormConfig({ step: 3 });
  });

  return (
    <section>
      <article className="container mb-4">
        <p className="">
          ¡Bienvenido a nuestra plataforma de pagos! Queremos explicarte los
          conceptos de pago que encontrarás aquí:
        </p>
        <hr />
        {errors.tipo && (
          <span className="mt-5 text-danger">{errors.tipo.message}</span>
        )}
        {watch("tipo") === "Cartera" && (
          <p className="text-type">
            <strong>1. Pago por concepto de cartera:</strong> Este pago
            corresponde a las mensualidades de tu membresía vacacional con Grupo
            Alianza Colombia. Es la inversión en experiencias únicas y
            exclusivas para ti y tu familia.
          </p>
        )}
        {watch("tipo") === "Reservas" && (
          <p className="text-type">
            <strong>2. Pago por reservas:</strong> Este pago se refiere a las
            reservas específicas que realices para tus viajes a destinos
            emocionantes. Garantiza tu alojamiento y servicios
            durante tus vacaciones.
          </p>
        )}
      </article>
      <form onSubmit={OnSubmit}>
        <div className="radio-inputs">
          <label>
            <input
              className="radio-input"
              type="radio"
              name="engine"
              {...register("tipo", {
                required:
                  "Debe escoger un concepto de pago, para poder continuar",
              })}
              value={"Cartera"}
            />
            <span className="radio-tile">
              <span className="radio-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="#000"
                  version="1.1"
                  viewBox="0 0 420 420"
                  xmlSpace="preserve"
                >
                  <g>
                    <path d="M252.877 92.823h53.791l.005 62.757 27.271-42.343V77.743a8.204 8.204 0 00-2.396-5.787L261.984 2.395A8.184 8.184 0 00256.199 0H41.113C27.579 0 16.566 11.008 16.566 24.543v370.914c0 13.534 11.012 24.543 24.547 24.543h268.283c13.533 0 24.545-11.009 24.545-24.543V290.15l-27.264 41.721.004 60.854H43.84V27.274h198.906v55.417a10.129 10.129 0 0010.131 10.132z"></path>
                    <path d="M364.398 195.123l-11.271-7.364a3.978 3.978 0 00-5.506 1.154l-60.688 92.866-11.67-7.625 60.688-92.867a3.975 3.975 0 00-1.153-5.506l-11.271-7.365a3.977 3.977 0 00-5.506 1.154l-90.869 139.053a3.99 3.99 0 00-.643 1.979l-2.375 48.258a3.978 3.978 0 005.746 3.754l43.243-21.553a3.964 3.964 0 001.558-1.385l90.867-139.052a3.97 3.97 0 00-1.15-5.501zM401.631 138.145l-40.869-26.708a3.979 3.979 0 00-5.506 1.154l-27.563 42.179a3.98 3.98 0 001.154 5.508l40.869 26.706a3.977 3.977 0 005.506-1.154l27.562-42.178a3.976 3.976 0 00-1.153-5.507zM83.563 87.462h78c5.523 0 10-4.478 10-10s-4.477-10-10-10h-78c-5.523 0-10 4.478-10 10s4.479 10 10 10zM231.563 127.462c0-5.522-4.479-10-10-10h-138c-5.523 0-10 4.478-10 10s4.477 10 10 10h138c5.523 0 10-4.478 10-10zM83.563 187.462h78c5.523 0 10-4.478 10-10s-4.477-10-10-10h-78c-5.523 0-10 4.478-10 10s4.479 10 10 10zM83.563 237.462h78c5.523 0 10-4.478 10-10 0-5.521-4.477-10-10-10h-78c-5.523 0-10 4.479-10 10 0 5.522 4.479 10 10 10zM87.796 366.694c-1.947 2.516 1.565 6.082 3.536 3.533 6.213-8.026 11.344-16.671 15.629-25.795 2.674 1.679 6.185 1.343 9.065.205 4.151-1.637 7.67-4.796 11.021-7.655 1.981-1.69 4.287-4.481 7.029-4.748 2.094-.201 4.922 1.485 7.015 1.844 5.469.932 11.857-.651 17.137-1.956 5.011-1.237 10.879-3.194 13.828-7.731 1.763-2.712-2.568-5.216-4.317-2.521-2.361 3.632-8.126 4.764-12.022 5.726-4.573 1.131-9.879 2.246-14.592 1.442-3.552-.604-6.425-2.752-10.077-1.125-4.892 2.18-8.629 6.761-12.949 9.854-1.933 1.384-4.142 2.714-6.56 2.901-.995.077-1.806-.288-2.48-.896.532-1.234 1.06-2.474 1.563-3.725 4.876-12.104 7.081-24.396 9.344-37.146 1.15-6.479 3.063-16.688-6.223-17.311-8.205-.548-15.296 11.287-17.918 17.524-2.345 5.578-2.606 12.058-2.427 18.014.111 3.712 1.447 7.566 2.432 11.404-7.874 1.263-14.814 9.216-13.598 17.1 1.197 7.758 10.898 3.752 14.521.881 3.667-2.905 4.854-6.534 4.893-10.448.731 1.205 1.342 2.65 1.974 4.002-4.225 9.477-9.522 18.485-15.824 26.627zm8.764-28.301c-.74 3.298-4.913 6.554-8.199 6.858-2.585.24-1.008-4.377-.497-5.409 1.604-3.242 5.578-5.358 8.919-6.27.156 1.627.131 3.239-.223 4.821zm4.176-9.681c-.851-3.976-2.032-7.969-2.338-11.583-.592-6.975.647-14.284 4.106-20.384 2.161-3.812 6.566-9.654 11.239-10.154 4.173-.444 1.628 9.705 1.267 11.744-1.117 6.294-1.914 12.541-3.471 18.763a140.452 140.452 0 01-5.469 17.095c-1.165-2.899-2.682-4.755-5.334-5.481z"></path>
                  </g>
                </svg>
              </span>
              <span className="radio-label">Pago por concepto de cartera</span>
            </span>
          </label>
          <label>
            <input
              className="radio-input"
              type="radio"
              name="engine"
              {...register("tipo", {
                required:
                  "Debe escoger un concepto de pago, para poder continuar",
              })}
              value={"Reservas"}
            />
            <span className="radio-tile">
              <span className="radio-icon">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                  <g>
                    <g>
                      <path
                        fill="#49BAA5"
                        d="M133.67 45.56H242.40999999999997V81.81H133.67z"
                      ></path>
                      <path
                        fill="#3AA38F"
                        d="M242.41 54.31L242.41 45.56 133.67 45.56 133.67 81.81 141.67 81.81 141.67 54.31"
                      ></path>
                      <path
                        fill="#E42A53"
                        d="M242.41 177.42a5 5 0 01-5-5V50.56h-98.74v121.86a5 5 0 01-10 0V45.56a5 5 0 015-5h108.74a5 5 0 015 5v126.86a5 5 0 01-5 5z"
                      ></path>
                      <path
                        fill="#D30045"
                        d="M242.41 244.91H61.18V450.9c0 11.34 10.3 20.539 23.01 20.539H270.5c-15.521 0-28.09-12.58-28.09-28.09V345.49c0-15.52 12.569-28.09 28.09-28.09h44.4V244.91h-72.49zM110.35 444.529c-7.14 0-12.92-6.309-12.92-14.09 0-7.039 3.23-10.561 9.69-14.08-6.46-3.52-9.69-7.039-9.69-14.08 0-7.789 5.78-14.1 12.92-14.1 12.91 0 20.271 14.1 33.18 28.18-12.91 14.08-20.27 28.17-33.18 28.17zm59.009-48.369c-20.17-18.49-40.33-29.031-40.33-47.52 0-10.211 9.03-18.49 20.16-18.49 10.08 0 15.13 4.619 20.17 13.869 5.04-9.25 10.08-13.869 20.16-13.869 11.16 0 20.19 8.279 20.19 18.49.001 18.489-20.189 29.03-40.35 47.52z"
                      ></path>
                      <g fill="#B50444">
                        <path d="M258.702 471.439H270.5a27.952 27.952 0 01-15.534-4.686 28.11 28.11 0 003.736 4.686zM69.347 459.234V253.243H314.9v-8.333H61.18V450.9c0 7.188 4.141 13.512 10.407 17.182a18.649 18.649 0 01-2.24-8.848z"></path>
                      </g>
                      <path
                        fill="#FFC230"
                        d="M110.35 388.18c12.91 0 20.271 14.1 33.18 28.18-12.909 14.08-20.27 28.17-33.18 28.17-7.14 0-12.92-6.309-12.92-14.09 0-7.039 3.23-10.561 9.69-14.08-6.46-3.52-9.69-7.039-9.69-14.08 0-7.79 5.78-14.1 12.92-14.1z"
                      ></path>
                      <path
                        fill="#EAA824"
                        d="M105.35 398.949c12.167 0 19.407 12.525 31.007 25.754 2.229-2.707 4.589-5.525 7.173-8.344-12.909-14.08-20.27-28.18-33.18-28.18-7.025 0-12.721 6.113-12.902 13.73 2.185-1.848 4.92-2.96 7.902-2.96z"
                      ></path>
                      <path
                        fill="#FFC230"
                        d="M189.52 330.15c11.16 0 20.19 8.279 20.19 18.49 0 18.488-20.19 29.029-40.351 47.52-20.17-18.49-40.33-29.031-40.33-47.52 0-10.211 9.03-18.49 20.16-18.49 10.08 0 15.13 4.619 20.17 13.869 5.04-9.249 10.08-13.869 20.161-13.869z"
                      ></path>
                      <path
                        fill="#EAA824"
                        d="M144.401 353.186c0-9.598 7.981-17.488 18.184-18.398-3.433-3.086-7.572-4.637-13.396-4.637-11.13 0-20.16 8.279-20.16 18.49 0 18.488 20.16 29.029 40.33 47.52a219.884 219.884 0 014.993-4.432c-16.17-13.403-29.951-23.258-29.951-38.543z"
                      ></path>
                      <path
                        fill="#EF3E5C"
                        d="M314.9 195.89v49.02H61.18v-49.02c0-12.96 10.3-23.47 23.01-23.47h207.699c12.711 0 23.011 10.51 23.011 23.47zm-90.61 21.83V199.6h-18.13v18.12h18.13zm-27.19 0V199.6h-18.12v18.12h18.12zm-27.18 0V199.6H151.8v18.12h18.12z"
                      ></path>
                      <path
                        fill="#E42A53"
                        d="M69.18 203.64c0-12.96 10.3-23.47 23.01-23.47h207.699c4.142 0 8.023 1.122 11.38 3.074-4.09-6.507-11.237-10.824-19.38-10.824H84.19c-12.71 0-23.01 10.51-23.01 23.47v49.02h8v-41.27z"
                      ></path>
                      <path
                        fill="#EF3E5C"
                        d="M346.61 136.17c7.51 0 13.59 6.09 13.59 13.59 0 7.51-6.08 13.6-13.59 13.6-7.5 0-13.591-6.09-13.591-13.6.001-7.5 6.091-13.59 13.591-13.59z"
                      ></path>
                      <path
                        fill="#E42A53"
                        d="M349.11 145.23c4.551 0 8.566 2.244 11.032 5.676.031-.379.058-.759.058-1.146 0-7.5-6.08-13.59-13.59-13.59-7.5 0-13.591 6.09-13.591 13.59 0 2.958.955 5.686 2.558 7.918.582-6.966 6.419-12.448 13.533-12.448z"
                      ></path>
                      <path
                        fill="#415A6B"
                        d="M450.82 345.49v16.07c-2.9.75-5.94 1.139-9.07 1.139-20.01 0-36.24-16.219-36.24-36.24 0-3.129.4-6.17 1.141-9.059h16.08c15.509 0 28.089 12.571 28.089 28.09z"
                      ></path>
                      <path
                        fill="#304856"
                        d="M412.521 333.959c0-3.129.4-6.17 1.141-9.059h16.08c6.238 0 12 2.035 16.663 5.477-4.991-7.803-13.727-12.977-23.674-12.977h-16.08a36.502 36.502 0 00-1.141 9.059c0 11.422 5.287 21.602 13.541 28.242a36.049 36.049 0 01-6.53-20.742z"
                      ></path>
                      <path
                        fill="#415A6B"
                        d="M450.82 427.279v16.07c0 15.51-12.58 28.09-28.09 28.09h-16.08c-.74-2.9-1.141-5.93-1.141-9.061 0-20.02 16.23-36.25 36.24-36.25 3.131.001 6.171.401 9.071 1.151z"
                      ></path>
                      <path
                        fill="#304856"
                        d="M412.521 467.379c0-20.02 16.23-36.25 36.24-36.25.691 0 1.377.027 2.06.066v-3.916c-2.9-.75-5.94-1.15-9.07-1.15-20.01 0-36.24 16.23-36.24 36.25 0 3.131.4 6.16 1.141 9.061h6.109a36.06 36.06 0 01-.24-4.061z"
                      ></path>
                      <path
                        fill="#415A6B"
                        d="M287.71 462.379c0 3.131-.39 6.16-1.14 9.061H270.5c-15.521 0-28.09-12.58-28.09-28.09v-16.07c2.89-.75 5.93-1.15 9.06-1.15 20.02-.001 36.24 16.229 36.24 36.249z"
                      ></path>
                      <path
                        fill="#304856"
                        d="M251.47 426.129c-3.13 0-6.17.4-9.06 1.15v6.555a36.015 36.015 0 016.06-.525c20.021 0 36.24 16.23 36.24 36.25 0 .633-.027 1.258-.059 1.881h1.919c.75-2.9 1.14-5.93 1.14-9.061 0-20.02-16.22-36.25-36.24-36.25z"
                      ></path>
                      <path
                        fill="#415A6B"
                        d="M286.57 317.4c.75 2.889 1.14 5.93 1.14 9.059 0 20.021-16.22 36.24-36.24 36.24-3.13 0-6.17-.389-9.06-1.139v-16.07c0-15.52 12.569-28.09 28.09-28.09h16.07z"
                      ></path>
                      <path
                        fill="#304856"
                        d="M248.41 352.229c0-15.52 12.57-28.09 28.09-28.09h11.138a35.71 35.71 0 00-1.067-6.738H270.5c-15.521 0-28.09 12.57-28.09 28.09v16.07c1.937.502 3.945.828 6 .998v-10.33z"
                      ></path>
                      <path
                        fill="#FFC230"
                        d="M305.84 380.83H387.39V417.07H305.84z"
                      ></path>
                      <path
                        fill="#EAA824"
                        d="M313.673 388.83L387.39 388.83 387.39 380.83 305.84 380.83 305.84 417.07 313.673 417.07z"
                      ></path>
                      <path
                        fill="#49BAA5"
                        d="M450.82 361.561v65.719c-2.9-.75-5.94-1.15-9.07-1.15-20.01 0-36.24 16.23-36.24 36.25 0 3.131.4 6.16 1.141 9.061h-120.08c.75-2.9 1.14-5.93 1.14-9.061 0-20.02-16.22-36.25-36.24-36.25-3.13 0-6.17.4-9.06 1.15v-65.719c2.89.75 5.93 1.139 9.06 1.139 20.021 0 36.24-16.219 36.24-36.24 0-3.129-.39-6.17-1.14-9.059H406.651a36.502 36.502 0 00-1.141 9.059c0 20.021 16.23 36.24 36.24 36.24a36.23 36.23 0 009.07-1.139zm-63.43 55.509v-36.24h-81.55v36.24h81.55z"
                      ></path>
                      <path
                        fill="#3AA38F"
                        d="M448.417 369.439c.808 0 1.608-.029 2.403-.08v-7.799c-2.9.75-5.94 1.139-9.07 1.139a36.067 36.067 0 01-22.219-7.621c6.618 8.725 17.094 14.361 28.886 14.361zM294.377 469.119c0-11.645-5.494-22-14.025-28.633a36.097 36.097 0 017.358 21.893c0 3.131-.39 6.16-1.14 9.061h7.734c.049-.768.073-1.542.073-2.321zM249.077 396.629v-28.33c2.89.75 5.93 1.141 9.06 1.141 20.021 0 36.24-16.221 36.24-36.24 0-3.131-.39-6.17-1.14-9.061h112.347a36.45 36.45 0 011.066-6.738H286.57c.75 2.889 1.14 5.93 1.14 9.059 0 20.021-16.22 36.24-36.24 36.24-3.13 0-6.17-.389-9.06-1.139v65.719a35.89 35.89 0 016.667-1.07v-29.581z"
                      ></path>
                      <path
                        fill="#FFC230"
                        d="M206.16 199.6H224.29V217.72H206.16z"
                      ></path>
                      <path
                        fill="#FFC230"
                        d="M178.979 199.6H197.09900000000002V217.72H178.979z"
                      ></path>
                      <path
                        fill="#FFC230"
                        d="M151.8 199.6H169.92000000000002V217.72H151.8z"
                      ></path>
                      <path
                        fill="#B50444"
                        d="M206.16 320.34a5 5 0 01-5-5v-63.43a5 5 0 1110 0v63.43a5 5 0 01-5 5zM169.92 320.34a5 5 0 01-5-5v-63.43a5 5 0 1110 0v63.43a5 5 0 01-5 5zM133.67 320.34a5 5 0 01-5-5v-63.43a5 5 0 1110 0v63.43a5 5 0 01-5 5zM97.43 320.34a5 5 0 01-5-5v-63.43a5 5 0 0110 0v63.43a5 5 0 01-5 5z"
                      ></path>
                      <path
                        fill="#3AA38F"
                        d="M378.33 322.4a5 5 0 01-5-5v-31.25H319.9v31.25c0 2.762-2.238 5-5 5s-5-2.238-5-5v-36.25a5 5 0 015-5h63.43a5 5 0 015 5v36.25a5 5 0 01-5 5z"
                      ></path>
                      <path
                        fill="#EF3E5C"
                        d="M404.105 218.891c7.51 0 13.59 6.09 13.59 13.59 0 7.51-6.08 13.6-13.59 13.6-7.5 0-13.591-6.09-13.591-13.6.001-7.5 6.091-13.59 13.591-13.59z"
                      ></path>
                      <path
                        fill="#E42A53"
                        d="M406.605 227.951c4.551 0 8.566 2.244 11.032 5.676.031-.379.058-.759.058-1.146 0-7.5-6.08-13.59-13.59-13.59-7.5 0-13.591 6.09-13.591 13.59 0 2.958.955 5.686 2.558 7.918.582-6.965 6.419-12.448 13.533-12.448z"
                      ></path>
                    </g>
                  </g>
                </svg>
              </span>
              <span className="radio-label">Pago por reservas</span>
            </span>
          </label>
        </div>

        <button disabled={isSubmitting} className="MercadoPago mt-4">
          {isSubmitting ? (
            <span className="spinner-border spinner-border-sm"></span>
          ) : (
            "Continuar"
          )}
        </button>
      </form>
    </section>
  );
};

export default TypePayment;
